import Draggable from "react-draggable";
import React, { useEffect, useRef, useState, FormEvent } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import Form from "../../../../components/common/form/Form";
import Modal from "../../../../components/common/form/Modal";
import InputField from "../../../../components/common/form/InputField";
import SelectField from "../../../../components/common/form/SelectField";
import { booleanChecks, createOptionListForSelectTag } from "../../../../helpers/utils/Utils";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import { useCreateParentAccountBySubdivisionIdMutation, useUpdateParentAccountMutation } from "../parentAccountApi";
import { useCreateChildAccountMutation, useUpdateChildAccountMutation } from "../childAccountApi";


// 👇 Props typing
interface ChildAccountFieldProps {
    show: boolean;
    setShow: (show: boolean) => void;
    formType: "Add" | "Update";
    childId?: string;
    title: any,
    childAccountData?: any;
}

// 👇 Component
export default function ChildAccountFields({
    show,
    setShow,
    formType,
    childId,
    title,
    childAccountData = null
}: ChildAccountFieldProps): JSX.Element {
    const { subdivisionId } = useParams<{ subdivisionId: string }>();
    const [creatApi, createApiRes] = useCreateChildAccountMutation();
    const [updateApi, updatepiRes] = useUpdateChildAccountMutation();


    const [block, setBlock] = useState("");
    const [lot, setLot] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [geoId, setGeoId] = useState("");

    const [disable, setDisable] = useState(false);

    let childAccountObj = {
        block: block,
        lot: lot,
        accountNumber: accountNumber,
        geoId: geoId,
        subdivisionId: subdivisionId

    }

    useEffect(() => {
        if (childAccountData !== null && childAccountData.data) {
            setBlock(childAccountData.data.block);
            setLot(childAccountData.data.lot);
            setAccountNumber(childAccountData.data.accountNumber);
            setGeoId(childAccountData.data.geoId);
        }
    }, [childAccountData]);

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();
        setDisable(true);

        if (block) {
            formType === "Add"
                ?
                creatApi({
                    requestBody: childAccountObj,
                    id: subdivisionId,
                }
                )
                : updateApi({
                    requestBody: childAccountObj,
                    id: childId,
                })
            setShow(false)
        }
    };

    return (
        <Modal
            title={title}
            show={show}
            setShow={setShow}
            className={"w-2/6  bg-text-0 text-surface-0"}
            fields={
                <>
                    <div className="modal-body">
                        <Form
                            onSubmit={handleSubmit}
                            fields={
                                <>
                                    <InputField
                                        label="Block"
                                        type="text"
                                        name="block"
                                        value={block ?? ""}
                                        onChange={(e) => setBlock(e.target.value)}
                                        placeholder="Enter Block..."
                                        required
                                    />
                                    <InputField
                                        label="Lot"
                                        type="text"
                                        name="lot"
                                        value={lot ?? ""}
                                        onChange={(e) => setLot(e.target.value)}
                                        placeholder="Enter Lot..."
                                        required
                                    />

                                    <InputField
                                        label="Account No"
                                        type="text"
                                        name="accountNumber"
                                        value={accountNumber ?? ""}
                                        onChange={(e) => setAccountNumber(e.target.value)}
                                        placeholder="Enter Account No..."
                                    />
                                    <InputField
                                        label="Geo Id"
                                        type="text"
                                        name="geoId"
                                        value={geoId ?? ""}
                                        onChange={(e) => setGeoId(e.target.value)}
                                        placeholder="Enter Geo Id..."
                                    />


                                    <div className="form-group row mt-3">

                                        <ButtonTray
                                            buttons={[
                                                {
                                                    buttonProps: {
                                                        btnText: "Cancel",
                                                        onClick: () => setShow(false),
                                                        type: "close",
                                                    },
                                                    buttonType: "button"
                                                },
                                                {
                                                    buttonProps: {
                                                        btnText: formType,
                                                        type: "submit",
                                                        isLoading: createApiRes.isLoading || updatepiRes.isLoading,
                                                    },
                                                    buttonType: "button",
                                                }
                                            ]}

                                            gap={2}
                                        />

                                    </div>
                                </>
                            }
                        />
                    </div>
                </>
            }
        />
    );
}
